module.exports = "<div class=\"dui-card dui-card--focused\">\n  <div class=\"text-center\">\n    \"{{name|e('html_attr')}}\" has been removed (<a href=\"javascript:void(0);\" class=\"dismiss\">dismiss</a>)\n  </div>\n</div>";
